module.exports = __webpack_public_path__ + "static/media/ic_date_confirmed.e9b51d28.svg";